import React from "react";
import { useSelector } from "react-redux";
import calculateWeeklyProfit from "../../utility/calculateWeeklyProfit";
import './main.css';
import CityMap from "../../components/cityMap/citymap";
import moment from "moment";

const Main = () => {
  const { data, headerIndexes } = useSelector((state) => state.data);

  if (!data || data.length === 0 || Object.keys(headerIndexes).length === 0) {
    return <div>Loading data...</div>;
  }  

  const { lastWeekProfit, prevWeekProfit, profitChange } = calculateWeeklyProfit(data, headerIndexes);
  const isProfitPositive = profitChange.Total > 0;

  const categories = ["Private", "Group", "Booklet"];

  const getCancelledByCity = (data, headerIndexes) => {
    if (!data || data.length === 0) return [];
  
    const typeIndex = headerIndexes["TYPE (labels)"];
    const statusIndex = headerIndexes["Status"];
    const cityIndex = headerIndexes["City"];
    const dateIndex = headerIndexes["Start Date"];
  
    if (
      typeIndex === undefined || 
      statusIndex === undefined || 
      cityIndex === undefined || 
      dateIndex === undefined
    ) {
      console.error("Missing required headers");
      return [];
    }
  
    const lastWeekStart = moment("11/30/2024", "MM/DD/YYYY");
    const lastWeekEnd = moment("12/06/2024", "MM/DD/YYYY");
  
    const cityCounts = data.reduce((acc, row) => {
      const type = row[typeIndex]?.trim();
      const status = row[statusIndex]?.trim();
      const city = row[cityIndex]?.trim();
      
      let date = moment(row[dateIndex], "YYYY-MM-DD", true); // Try YYYY-MM-DD format first
      if (!date.isValid()) {
        date = moment(row[dateIndex], "DD/MM/YYYY", true); // Fallback to DD/MM/YYYY
      }
      if (!date.isValid()) {
        date = moment(row[dateIndex], "YYYY/MM/DD", true); // Fallback to YYYY/MM/DD
      }
  
      // Check if the date is valid
      if (!date.isValid()) {
        console.warn(`Invalid date format for row: ${JSON.stringify(row)}`);
        return acc;
      }
  
      if (
        type === "Private" && 
        status === "CANCELLED BY US" && 
        city &&
        date.isValid() &&
        date.isBetween(lastWeekStart, lastWeekEnd, undefined, "[]")
      ) {
        acc[city] = (acc[city] || 0) + 1;
      }
      return acc;
    }, {});
  
    return Object.entries(cityCounts)
      .map(([city, count]) => ({ city, count }))
      .sort((a, b) => b.count - a.count);
  };
  

  const cancelledByCity = getCancelledByCity(data, headerIndexes);

  return (
    <div className="wrapperContainer">
      <div className="topContainer">
        <div className="revenueContainer">
          <div className="revenueHeading">Revenue</div>
          <div className={`revenueNumber ${isProfitPositive ? 'positive' : 'negative'}`}> 
            {profitChange.Total}% 
            <span className={`arrow ${isProfitPositive ? 'up' : 'down'}`}>
              <img 
                src={isProfitPositive ? '/trending_up.svg' : '/trending_down.svg'} 
                alt="arrow"
                className="arrow-icon"
                style={{
                  filter: isProfitPositive
                    ? 'invert(29%) sepia(92%) saturate(320%) hue-rotate(100deg) brightness(93%) contrast(88%)'
                    : 'invert(29%) sepia(92%) saturate(320%) hue-rotate(0deg) brightness(93%) contrast(88%)'
                }}
              />
            </span>
          </div>
          <div className="comparisonContainer">
            <div className="comparisonContainerChild1">
              <div>Current Week</div>
              <span>{lastWeekProfit.Total} $</span>
            </div>
            <div className="comparisonContainerChild2">
              <div>Previous Week</div>
              <span>{prevWeekProfit.Total} $</span>
            </div>
          </div>
        </div>
        <div className="breakdownContainer">
          <div className="breakdownContainerHeading">Revenue by Category -</div>
          <div className="breakdownContainerTable">
            <table>
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Previous Week</th>
                  <th>Current Week</th>
                  <th>Change</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((category) => {
                  const prevRevenue = prevWeekProfit[category] || 0;
                  const currRevenue = lastWeekProfit[category] || 0;
                  const change = profitChange[category] || 0;
                  const isPositive = change > 0;

                  return (
                    <tr key={category}>
                      <td>{category}</td>
                      <td>{prevRevenue.toFixed(2)}$</td>
                      <td>{currRevenue.toFixed(2)}$</td>
                      <td className={isPositive ? "positive" : "negative"}>
                       {isPositive ? '▲' : '▼'} {currRevenue - prevRevenue}$ ({change.toFixed(2)}%)
                      </td>
                    </tr>
                  ); 
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="bookingPlatformChart">maybe show booking platform % chart? Ask Rafal!</div>
      </div>
      <div className="secondContainer"><div className="cityMapContainer"><CityMap/></div>
      <div className="cnlbyusContainer">
        <div className="cnlbyusHeading">
         <div>Cancelled by Us <span>(Last week)</span></div>
         </div>
        <div className="cnlbyusTableContainer">
         <table className="cnlbyusTable">
          <thead>
           <tr>
            <th>City</th>
            <th>Count</th>
           </tr>
          </thead>
          <tbody>
           {/* Map through cancelledByCity */}
            {cancelledByCity.map(({ city, count }) => (
             <tr key={city}>
              <td>{city}</td>
              <td>{count}</td>
             </tr>
            ))}
          </tbody>
         </table>
        </div>
      </div>
      </div>
      </div>
  );
};

export default Main;
